module.exports = __webpack_public_path__ + "static/media/Elevate_customer_experience.5dd59b48.png";